// Cookie consent manager using localStorage
const COOKIE_CONSENT_KEY = 'synkro_cookie_consent';

export type CookieConsentChoice = 'accepted' | 'rejected' | 'pending';

export interface CookieConsentSettings {
  choice: CookieConsentChoice;
  timestamp: number;
  version: string;
}

const CookieConsentManager = {
  // Get current consent status
  getConsent: (): CookieConsentSettings => {
    try {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (stored) {
        const parsed = JSON.parse(stored) as CookieConsentSettings;
        return parsed;
      }
    } catch (error) {
      console.warn('Error reading cookie consent from localStorage:', error);
    }

    // Default state - not yet asked
    return {
      choice: 'pending',
      timestamp: 0,
      version: '1.0'
    };
  },

  // Check if user has made a choice (accepted or rejected)
  hasMadeChoice: (): boolean => {
    const consent = CookieConsentManager.getConsent();
    return consent.choice !== 'pending';
  },

  // Check if user has accepted cookies
  hasAccepted: (): boolean => {
    const consent = CookieConsentManager.getConsent();
    return consent.choice === 'accepted';
  },

  // Accept cookies
  acceptCookies: (): void => {
    const settings: CookieConsentSettings = {
      choice: 'accepted',
      timestamp: Date.now(),
      version: '1.0'
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(settings));
  },

  // Reject cookies
  rejectCookies: (): void => {
    const settings: CookieConsentSettings = {
      choice: 'rejected',
      timestamp: Date.now(),
      version: '1.0'
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(settings));
  },

  // Reset consent (for testing or if user wants to change)
  resetConsent: (): void => {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  }
};

export default CookieConsentManager;
